import { createFileRoute } from "@tanstack/react-router";
import { AiTeammatesMarketingGoogleAdsPage } from "@/components/seo/ai-teammates-marketing-google-ads-page";
import {
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_FAQ_SCHEMA_ITEMS,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_META_DESCRIPTION,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_PAGE_TITLE,
} from "@/constants/seo/ai-teammates-marketing-google-ads-content";
import {
	buildBreadcrumb,
	buildFAQ,
	buildSoftwareApplication,
	buildWebPage,
	jsonLdScript,
} from "@/lib/seo/json-ld";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

export const Route = createFileRoute("/ai-teammates/marketing/google-ads")({
	head: () => {
		const canonical = getCanonical("/ai-teammates/marketing/google-ads");
		const meta = buildMetaTags({
			title: "Google Ads AI – Automated Campaign Monitoring",
			description: AI_TEAMMATES_MARKETING_GOOGLE_ADS_META_DESCRIPTION,
			canonical,
			ogType: "website",
		});

		const schemas = [
			buildWebPage({
				name: AI_TEAMMATES_MARKETING_GOOGLE_ADS_PAGE_TITLE,
				description: AI_TEAMMATES_MARKETING_GOOGLE_ADS_META_DESCRIPTION,
				url: canonical,
			}),
			buildFAQ(AI_TEAMMATES_MARKETING_GOOGLE_ADS_FAQ_SCHEMA_ITEMS),
			buildBreadcrumb([
				{ name: "Home", url: getCanonical("/") },
				{ name: "AI Teammates", url: getCanonical("/ai-teammates") },
				{ name: "Marketing", url: getCanonical("/ai-teammates/marketing") },
				{ name: "Google Ads", url: canonical },
			]),
			buildSoftwareApplication({ ratingValue: 4.8, ratingCount: 50, price: "0" }),
		];

		return {
			meta,
			links: buildLinks({ canonical }),
			scripts: schemas.map(jsonLdScript),
		};
	},
	component: AiTeammatesMarketingGoogleAdsPage,
});
